"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddonsAPI = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getAddonsAPI = function getAddonsAPI(url, param) {
  return _axios.default.get("".concat(url, "?").concat(param)).then(function (res) {
    return res.data;
  }).catch(function (e) {
    throw e.response;
  });
};
exports.getAddonsAPI = getAddonsAPI;